import { Component, OnInit } from '@angular/core';
import { BookingConfirmationTemplate } from '../booking-confirmation-template';
import { HttpService } from '../service/http.service';
import { PdfDocumentTemplateService } from '../pdf-document-template.service';
import { PdfTemplateViewOption } from '../pdf-template-view-option.enum';
import { ToastMessageService } from '../toast-message.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-booking-confirmation-templates',
  templateUrl: './booking-confirmation-templates.component.html',
  styleUrls: ['./booking-confirmation-templates.component.css']
})
export class BookingConfirmationTemplatesComponent implements OnInit {

  constructor(
    private httpService: HttpService,
    public templateService: PdfDocumentTemplateService,
    private confirmationService: ConfirmationService,
    private toastService: ToastMessageService
  ) { }

  templates: BookingConfirmationTemplate[] = [];

  ngOnInit(): void {
    this.httpService.getBookingConfirmationTemplatesByLanguageId(this.templateService.selectedLanguage.id).subscribe(res => {
      this.templateService.confirmationTemplates = res;
    });
  }

  selectTemplateToEdit(template: BookingConfirmationTemplate) {
    this.templateService.selectedConfirmationTemplate = template;
    this.templateService.activeItemId = PdfTemplateViewOption.EDIT_CONFIRMATION;
  }

  deleteTemplate(templateId: number){
    this.confirmationService.confirm({
      message: "Do you waint to delete the confirmation template id: " + templateId + "?",
      accept: () => {
        this.httpService.deleteBookingConfirmationTemplate(templateId).subscribe(() => {
          this.removeTemplateFromArray(templateId);
          this.toastService.addSuccess("Success", "Template deleted");
        }, error => this.toastService.addError("Error", "Template could not be deleted"));
      }
    });
  }

  removeTemplateFromArray(templateId: number){
    for(let template of this.templateService.confirmationTemplates){
      if(template.id == templateId){
        const index = this.templateService.confirmationTemplates.indexOf(template);
        this.templateService.confirmationTemplates.splice(index, 1);
      }
    }
  }

}